import { useState } from "react";
import { computeTrust } from "@/lib/trust";

const SEAL = "/brand/verified-seal.png";
const CAMPUS = "/brand/campus-line.png";

// Real verified campus photo when available; otherwise a premium
// "CollegeUnlock Verified" trust seal — intentional, branded, never a placeholder.
export default function CollegeImage({ src, alt = "", label, className = "" }) {
  const [imgError, setImgError] = useState(false);

  if (src && !imgError) {
    return (
      <img src={src} alt={alt} loading="lazy" onError={() => setImgError(true)} className={`h-full w-full object-cover ${className}`} />
    );
  }

  const { score } = computeTrust({}, alt || label || "");
  return (
    <div
      data-testid="verified-institution-visual"
      className={`relative flex h-full w-full items-center justify-center overflow-hidden bg-gradient-to-br from-[#0B2352] via-[#122f74] to-[#16398c] vih-sweep ${className}`}
    >
      <div className="pointer-events-none absolute inset-0 vih-grid opacity-[0.06]" />
      <img src={CAMPUS} alt="" aria-hidden className="pointer-events-none absolute inset-x-0 -bottom-3 mx-auto w-40 opacity-[0.07]" />
      <div className="pointer-events-none absolute -top-6 -right-6 h-20 w-20 rounded-full bg-[#D4A24C]/20 blur-2xl" />
      <div className="relative flex flex-col items-center">
        <div className="relative h-10 w-10">
          <div className="absolute inset-0 rounded-full bg-[#D4A24C]/25 blur-md" />
          <img src={SEAL} alt="CollegeUnlock Verified" className="relative h-full w-full object-contain drop-shadow-[0_3px_7px_rgba(0,0,0,0.45)]" />
        </div>
        <p className="mt-1.5 cu-gold-text text-[8.5px] font-bold tracking-[0.16em] opacity-90">COLLEGEUNLOCK VERIFIED</p>
      </div>
      <span className="absolute bottom-2 right-2.5 rounded-full border border-[#D4A24C]/35 bg-black/20 px-2 py-0.5 text-[9px] font-semibold text-[#E9C877]/90 backdrop-blur-sm">Trust {score}%</span>
    </div>
  );
}
